import React from 'react';
import packageJson from '../../../package.json';
import { PROVIDER } from '../../constants/provider';
import { useAuth } from '../../contexts/authContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { FooterInner, FooterStrip } from './styles';

/**
 * Faixa com razão social/CNPJ do fornecedor e versões. Usada no balcão e na
 * tela de login.
 */
const AppFooter: React.FC = () => {
  const { apiVersion } = useAuth();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.bodyStep);

  return (
    <FooterStrip>
      <FooterInner>
        <span>
          {tp('providerLabel')} {PROVIDER.legalName} - CNPJ: {PROVIDER.cnpj}
        </span>
        <span>
          {tp('versionLabel')} {packageJson.version}
          {apiVersion ? ` · ${tp('apiVersionLabel')} ${apiVersion}` : ''}
        </span>
      </FooterInner>
    </FooterStrip>
  );
};

export default AppFooter;
